import React, { useEffect, useState } from 'react';
import { TrashIcon } from '@heroicons/react/24/solid';
import axios from '../../../axios';
import M from 'materialize-css';

const CategoriaPrecioForm = ({ categoria, setProductoSelected, setUpdated }) => {
    const [listado, setListado] = useState({ precio: 0.00 });
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        if (categoria.pivot) {
            setListado(categoria.pivot);
        }
    }, [categoria]);

    const _savePrecio = () => {
        setSaving(true);
        axios.post('api/save-category-price', listado)
            .then((resp) => {
                if (resp.status === 200) {
                    updateService();
                    M.toast({
                        html: `<i class="material-icons">check_circle</i> &nbsp;&nbsp;<span>${resp.data.message}</span>`,
                        classes: "success-notify"
                    });
                }
            })
            .catch(e => console.log("Error:", e))
            .finally(() => setSaving(false));
    };

    const deletePrecio = () => {
        if (!window.confirm('¿Estás seguro de eliminar este precio de categoría?')) {
            return;
        }
        
        setDeleting(true);
        axios.post('api/delete-category-price', listado)
            .then((resp) => {
                if (resp.status === 200) {
                    updateService();
                    M.toast({
                        html: `<i class="material-icons">check_circle</i> &nbsp;&nbsp;<span>${resp.data.message}</span>`,
                        classes: "success-notify"
                    });
                }
            })
            .catch(e => console.log("Error:", e))
            .finally(() => setDeleting(false));
    };

    const updateService = () => {
        axios.get(`api/products/${listado.product_id}`)
            .then((resp) => {
                setProductoSelected(resp.data);
                setUpdated(true);
            })
            .catch(e => console.log("Error:", e));
    };

    return (
        <div className="p-4">
            <div className="flex items-end gap-4">
                {/* Input de precio */}
                <div className="flex-1">
                    <label 
                        htmlFor={`precio-${categoria.id}`}
                        className="block text-sm font-medium text-gray-700 mb-1"
                    >
                        Precio
                    </label>
                    <div className="relative">
                        <span className="absolute -left-1 top-1/2 -translate-y-1/2 text-gray-800 text-lg">
                            $
                        </span>
                        <input
                            id={`precio-${categoria.id}`}
                            type="number"
                            step="any"
                            min="0"
                            value={listado.precio}
                            onChange={(e) => setListado({ ...listado, precio: e.target.value })}
                            onBlur={_savePrecio}
                            disabled={saving}
                            className="w-full pl-7 pr-4 py-2 dento-input transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                            placeholder="0.00"
                        />
                        {saving && (
                            <span className="absolute right-3 top-1/2 -translate-y-1/2">
                                <svg className="animate-spin h-4 w-4 text-blue-500" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                </svg>
                            </span>
                        )}
                    </div>
                </div>

                {/* Botón eliminar */}
                <button
                    onClick={deletePrecio}
                    disabled={deleting}
                    className="inline-flex items-center justify-center p-2.5 text-red-600 bg-red-50 rounded-lg hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    title="Eliminar precio"
                >
                    {deleting ? (
                        <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                    ) : (
                        <TrashIcon className="h-5 w-5" />
                    )}
                </button>
            </div>
        </div>
    );
};

export default CategoriaPrecioForm;